<template>
  <div class="px-4" style="min-height: 480px;">
    <v-form v-if="indexCustomer > -1">
      <validation-provider
        v-slot="{ errors }"
        :vid="indexCustomer === 0 ? 'Tên con' : `Tên con ${indexCustomer +1}`"
        name="Tên con"
        :rules="{required: !customer.isMainCustomer, max:255}"
      >
        <v-text-field
          :disabled="customer.isMainCustomer"
          v-model="customer.fullName"
          :label="indexCustomer === 0 ? 'Tên con *' : `Tên con ${indexCustomer +1} *`"
          :error-messages="errors"
          color="primary"
          :readonly="customer.vhUserId && !checkAuthorization('contact_change_user_read')"
        />
      </validation-provider>
      <validation-provider
        v-slot="{ errors }"
        name="Năm sinh của con"
        :vid="indexCustomer === 0 ? 'Năm sinh của con' : `Năm sinh của con ${indexCustomer +1}`"
        rules="required"
      >
        <common-select-year
          v-model="customer.birthday"
          :label="indexCustomer === 0 ? 'Năm sinh của con *' : `Năm sinh của con ${indexCustomer +1} *`"
          :error-messages="errors"
        />
      </validation-provider>
      <validation-provider
        v-slot="{ errors }"
        name="Độ tuổi"
        :vid="indexCustomer === 0 ? 'Độ tuổi của con' : `Độ tuổi của con ${indexCustomer +1}`"
        rules="max:255"
      >
        <v-text-field
          v-model="customer.birthdayDescription"
          :label="indexCustomer === 0 ? 'Độ tuổi của con' : `Độ tuổi của con ${indexCustomer +1}`"
          :error-messages="errors"
        />
      </validation-provider>

      <validation-provider v-slot="{ errors }" name="Học lực" rules="max:255">
        <v-text-field
          v-model="customer.capability"
          :label="indexCustomer === 0 ? 'Học lực' : `Học lực ${indexCustomer +1}`"
          :error-messages="errors"
          color="primary"
        />
      </validation-provider>
      <validation-provider
        v-slot="{ errors }"
        name="SĐT (nếu có)"
        :vid="indexCustomer === 0 ? 'SĐT (nếu có)' : `SĐT (nếu có) ${indexCustomer +1}`"
        :rules="{ regex: regex.isVNPhoneMobile }"
      >
        <v-text-field
          :disabled="customer.isMainCustomer"
          v-model="customer.mobile"
          label="SĐT (nếu có)"
          :error-messages="errors"
          color="primary"
          type="number"
        />
      </validation-provider>
      <validation-provider v-slot="{ errors }" name="Khoá học đăng ký" rules="max:255">
        <v-text-field
          v-model="customer.productDescription"
          label="Khoá học đăng ký"
          :error-messages="errors"
        />
      </validation-provider>

      <validation-provider v-if="checkAuthorization('every-order_read')" v-slot="{ errors }" name="Tài khoản vuihoc" rules="max:255" style="display: flex">
        <v-text-field
            v-model="customer.vhUserId"
            label="Tài khoản vuihoc"
            :error-messages="errors"
            readonly
        />
<!--        <span-->
<!--            @click="updateVhUserId()"-->
<!--            color="success"-->
<!--            class="btn-update-vh-user-id"-->
<!--        > Lưu lại-->
<!--          <v-icon color="white">mdi-update</v-icon>-->
<!--        </span>-->
      </validation-provider>

      <template v-for="(contactColumn, indexContact) in contactColumnList">
        <v-text-field
          v-if="contactColumn.type === 'text'"
          :key="'indexContact_' + indexContact"
          v-model="customer[contactColumn.id]"
          :label="contactColumn.description"
          color="primary"
        />
        <v-textarea
          v-else-if="contactColumn.type === 'textarea'"
          :key="'indexContact_' + indexContact"
          v-model="customer[contactColumn.id]"
          :label="contactColumn.description"
          rows="2"
        />
      </template>
    </v-form>
    <v-card-actions v-show="showAddCustomer" style="text-align: right;">
      <v-btn color="success" @click="onClickAddChild">
        <v-icon>mdi-plus</v-icon>Thêm con
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { regex, contactDetail } from '../../../helpers/constants';
import RepositoryFactory from '../../../repositories/RepositoryFactory';
const ContactRepository = RepositoryFactory.get('contact');

export default {
  props: {
    contactColumns: {
      type: Object,
      default: () => ({})
    },
    customer: {
      type: Object,
      default: () => {}
    },
    indexCustomer: {
      type: Number,
      default: -1
    },
    dataForm: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      regex
    };
  },
  computed: {
    contactColumnList() {
      return _.get(this.contactColumns, 'child', []) || [];
    },
    showAddCustomer() {
      return (
        this.indexCustomer + 1 === this.customersLength 
        && this.customersLength < 7
      );
    },
    customersLength() {
      return this.dataForm.customers.filter(
        customer =>
          customer.position === 'child' && !_.get(customer, 'isDeleted', false)
      ).length;
    }
  },
  methods: {
    onClickAddChild() {
      // if (this.customersLength === contactDetail.MAX_CONTACT) {
      //   return this.$swal({
      //     type: 'error',
      //     title: 'Lỗi !',
      //     text: 'Bạn chỉ có thể tạo tối đa 5 thông tin con'
      //   });
      // }
      this.dataForm.customers.push({
        customerId: new Date().getTime(),
        isMainCustomer: false,
        position: 'child',
        courseRegister: [],
        productDescription: '',
        isNew: true
      });
    },
    async updateVhUserId() {
      const dataUpdate = {
        vhUserId: this.customer.vhUserId
      }
      const loader = this.$loading.show()
      const response = await ContactRepository.updateCustomerVhUserId(
          dataUpdate,
          this.customer.id
      );
      loader.hide()
      if (response.success) {
        this.$swal({
          title: 'Cập nhật vhUserId khách hàng thành công!',
          confirmButtonText: 'Đồng ý',
          timer: 1000
        });
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      }

    }
  }
};
</script>

<style scoped>
.btn-update-vh-user-id {
  height: fit-content;
  background: #4caf50;
  border-radius: 5px;
  padding: 4px 8px;
  cursor: pointer;
  color: white;
  margin-top: 20px;
  margin-left: 10px;
}
</style>